<script setup>
import DefaultInput from "@/components/global-themed/inputs/DefaultInput.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import useAdvancedRevisionFeedback from "@/composables/approval-center/advanced-revision/useAdvancedRevisionFeedback";

const {type} = defineProps({
  type: {
    type: String,
    required: true,
  },
});

const {fullFeedback} = useAdvancedRevisionFeedback();
const {revisionErrors: errors} = useApprovalFlow();
</script>

<template>
  <div class="tw-mb-8 tw-flex tw-flex-col tw-gap-4">
    <div class="tw-text-neutral-900 tw-font-bold">
      Feedback On The Full {{ type }}
    </div>
    <DefaultInput
      id="advanced-feedback-general-input"
      v-model="fullFeedback"
      placeholder="E.g. suggest a different tone-of-voice, request a change of topic, or give feedback on the overall structure or relevance of the post"
    />
    <p
      v-if="errors?.feedback"
      class="tw-text-danger"
    >
      {{ errors.feedback[0] }}
    </p>
  </div>
</template>
